"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _PreviewLoader = _interopRequireDefault(require("./PreviewLoader"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _jsxFileName = "/opt/build/repo/plugins/wordsby-master/src/components/Preview/index.js";

var Preview =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Preview, _Component);

  function Preview(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPreviewDataFromPostRobot",
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var response, previewData;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(getParameter("nonce") && getParameter("preview") && getParameter("userId") && !_this.state.previewData)) {
                _context.next = 19;
                break;
              }

              _context.next = 3;
              return fetch(_this.props.pageContext.siteUrl + "/wp-json/wp/v2/previewData?preview=" + getParameter("preview") + "&nonce=" + getParameter("nonce") + "&userId=" + getParameter("userId"));

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.status;

            case 6:
              _context.t1 = _context.sent;
              _context.t0 = _context.t1 !== 200;

              if (!_context.t0) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return response.status;

            case 11:
              _context.t2 = _context.sent;
              _context.t0 = _context.t2 !== 201;

            case 13:
              if (!_context.t0) {
                _context.next = 15;
                break;
              }

              throw new Error("Failed!");

            case 15:
              _context.next = 17;
              return response.json();

            case 17:
              previewData = _context.sent;

              _this.setState({
                previewData: previewData
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      previewData: false,
      error: false
    };
    _this.getPreviewDataFromPostRobot = _this.getPreviewDataFromPostRobot.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = Preview.prototype;

  _proto.componentDidMount = function componentDidMount() {
    return this.getPreviewDataFromPostRobot();
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.props.data && this.state.previewData && typeof window !== "undefined") {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$data = _this$props.data,
          wordpressWpCollections = _this$props$data.wordpressWpCollections,
          wordsbyCollections = _this$props$data.wordsbyCollections,
          rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props$data, ["wordpressWpCollections", "wordsbyCollections"]);

      var childrenWithPreview = _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          data: (0, _extends2.default)({
            wordsbyCollections: _this2.state.previewData
          }, rest),
          previewData: (0, _extends2.default)({
            wordsbyCollections: _this2.state.previewData
          }, rest)
        });
      });

      return childrenWithPreview;
    } else {
      return _react.default.createElement(_PreviewLoader.default, {
        error: this.state.error,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        },
        __self: this
      });
    }
  };

  return Preview;
}(_react.Component);

var PreviewContainer = function PreviewContainer(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactHelmet.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    },
    __self: this
  }, _react.default.createElement("meta", {
    name: "robots",
    content: "noindex",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88
    },
    __self: this
  })), _react.default.createElement(Preview, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90
    },
    __self: this
  })));
};

var _default = PreviewContainer;
exports.default = _default;

function getParameter(parameterName) {
  var result = false,
      tmp = [];

  if (typeof window !== "undefined") {
    window.location.search.substr(1).split("&").forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  }

  return result;
}